// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

class TableExcelUploadSizeLimitPopup extends Component {
  state = {};

  render() {
    return (
      <Modal
        open
        onClose={this.props.closePopup}
        closeOnOverlayClick={false}
        center>
        <div
          className="modal-container table-gsheet-popup-container"
          data-test="table-gsheet-popup-container">
          <div
            className="modal-heading table-to-gsheet-heading"
            data-test="table-gsheet-popup-modal-heading">
            <span role="img" aria-label="">
              ⚠️
            </span>{" "}
            <span>File is too large</span>
          </div>
          <div className="modal-form">
            <div
              className="modal-form-field"
              data-test="table-gsheet-popup-form">
              Please upload xls or xlsx file of size less than 1 MB
            </div>
          </div>

          <div className="modal-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="table-gsheet-popup-cancle-btn"
              onClick={this.props.closePopup}>
              Dismiss
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default TableExcelUploadSizeLimitPopup;
